import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "react-perfect-scrollbar/dist/css/styles.css";
import $ from "jquery";
import VideoPlayer from "./common/VideoPlayer";
import SharePopup from "./common/Sharepopup";
import {
  playpause,
  hideplayIcon,
  handlePlayerReady,
  apiRequest,
  API_URL,
  EPISODE_URL,
  EPISODE_DATA_URL,
} from "./utils/Helper";
import CharchaShorts from "./AllEpisode/AllEpisode_Components/CharchaShorts";
import CharachaLekh from "./AllEpisode/AllEpisode_Components/CharachaLekh";
import TextCard from "./AllEpisode/AllEpisode_Components/TextCard";

import data from "./common/ShareText.json";

const Detail = () => {
  const [detail, setDetail] = useState();
  const [link, setLink] = useState("");
  const [quote, setQuote] = useState("");
  const [twittermessage, setTwittermessage] = useState("");
  const [shareType, setShareType] = useState("");
  const { id, lang, type, episodeId } = useParams();

  useEffect(() => {
    if (!episodeId) {
      fetchHomeData();
    }
    if (episodeId) {
      fetchEpisodeData();
    }
  }, []);

  useEffect(() => {
    console.log(detail);
  }, [detail]);

  const fetchEpisodeData = async () => {
    const url = `${EPISODE_DATA_URL}&episode_id=${episodeId}&id=${id}`;
    try {
      const response = await apiRequest(url);
      if (response && response._resultflag == 1) {
        setDetail(response.data);
        // if (type === "video") {
        //   const videos = response?.data[0]?.parikshadata?.video;
        //   const matchedDetail = videos.find((video) => video.id == id);
        // } else if (type === "shorts") {
        //   const shorts = response?.data[0]?.parikshadata?.shorts;
        //   const matchedDetail = shorts.find((short) => short.id == id);
        //   console.log(matchedDetail);

        //   setDetail(matchedDetail);
        // } else if (type === "graphics") {
        //   const graphics = response?.data[0]?.parikshadata?.graphics;
        //   const matchedDetail = graphics.find((graphic) => graphic.id == id);

        //   setDetail(matchedDetail);
        // } else if (type === "text") {
        //   const text = response?.data[0]?.parikshadata?.text;
        //   const matchedDetail = text.find((text) => text.id == id);
        //   setDetail(matchedDetail);
        // }
      }
    } catch (error) {
      console.error("Failed to fetch episode data:", error);
    }
  };

  const fetchHomeData = async () => {
    try {
      const url = `${EPISODE_URL}&episode_id=${id}&id=${id}`;
      try {
        const response = await apiRequest(url);
        if (response && response._resultflag == 1) {
          setDetail(response.data[0]);
          // if (type === "video") {
          //   const videos = response?.data[0]?.parikshadata?.video;
          //   const matchedDetail = videos.find((video) => video.id == id);
          // } else if (type === "shorts") {
          //   const shorts = response?.data[0]?.parikshadata?.shorts;
          //   const matchedDetail = shorts.find((short) => short.id == id);
          //   console.log(matchedDetail);

          //   setDetail(matchedDetail);
          // } else if (type === "graphics") {
          //   const graphics = response?.data[0]?.parikshadata?.graphics;
          //   const matchedDetail = graphics.find((graphic) => graphic.id == id);

          //   setDetail(matchedDetail);
          // } else if (type === "text") {
          //   const text = response?.data[0]?.parikshadata?.text;
          //   const matchedDetail = text.find((text) => text.id == id);
          //   setDetail(matchedDetail);
          // }
        }
      } catch (error) {
        console.error("Failed to fetch episode data:", error);
      }
    } catch (error) {
      console.error("Failed to fetch episode data:", error);
    }
  };

  const share = (id, share_text, type = "detail") => {
    $(".popup_fixed_bg").show();

    let link = `https://www.narendramodi.in/empowering/${type}/${id}`;
    setLink(link);
    setQuote(share_text ? share_text : "");
    setTwittermessage(share_text ? share_text : "");
    setShareType(type);
  };

  const getArticleTypeHtml = (type) => {
    if (type == "text") {
      return detail ? <TextCard text={detail} /> : null;
    } else if (type == "graphics") {
      return (
        <div className="textcard_pad">
          <div className="textcard_bg">
            {detail && detail.image_url && (
              <img src={detail.image_url} className="visual_banner" alt="" />
            )}
          </div>
        </div>
      );
    } else {
      return (
        <>
          <div
            className="videtab_div"
            style={type == "shorts" ? { width: "300px" } : {}}
          >
            <div className="video_tab video_tab2">
              {detail && (
                <>
                  {type == "shorts" ? (
                    <VideoPlayer
                      height={"68vh"}
                      width={"300px"}
                      onReady={handlePlayerReady}
                      id={detail.id}
                      keyi={detail.id}
                      key={detail.id}
                      type={type}
                      video_url={detail.video_url}
                      thumb={detail.image_url}
                    />
                  ) : (
                    <VideoPlayer
                      // height={"100vh"}
                      onReady={handlePlayerReady}
                      id={detail.id}
                      keyi={detail.id}
                      key={detail.id}
                      type={type}
                      video_url={detail.video_url}
                      thumb={detail.image_url}
                    />
                  )}

                  <span
                    className="play_layer"
                    onClick={() => {
                      playpause(detail.id, type);
                    }}
                    onMouseMove={() => {
                      hideplayIcon(detail.id, type);
                    }}
                  >
                    <img
                      src="/assets/images/play2.svg"
                      className={"play_icon playpausebtn_" + detail.id}
                      alt=""
                    />
                  </span>
                  <span
                    className="main_play"
                    onClick={() => {
                      playpause(detail.id);
                    }}
                  ></span>
                </>
              )}
            </div>
            <ul className="share_list share_listdetail">
              <li>
                <button onClick={() => share(detail.id, data[episodeId], type)}>
                  <img
                    src="/assets/images/shareorange.svg"
                    className="sh_or"
                    alt=""
                  />
                  <img
                    src="/assets/images/sharewhite.svg"
                    className="sh_wh"
                    alt=""
                  />{" "}
                  Share Video
                </button>
              </li>
            </ul>
          </div>
        </>
      );
    }
  };

  const params = new URLSearchParams(window.location.search);
  return (
    <>
      <div className="header_bg_topic">
        <div className="header_detail_bg">
          <div className="container-fluid">
            <ul className="header_top header_detail">
              <li>
                {lang == "en" ? (
                  <Link to="">
                    <img
                      src="/assets/vimages/parikshapecharcha_logo.svg"
                      alt=""
                    />
                  </Link>
                ) : (
                  <Link to="">
                    <img
                      src="/assets/vimages/parikshapecharcha_logo.svg"
                      alt=""
                    />
                  </Link>
                )}
              </li>

              <li>
                <Link
                  to={
                    window.location.href.indexOf("appversion") != -1
                      ? "/parikshapecharcha2025?" + params
                      : "/parikshapecharcha2025"
                  }
                  target={
                    window.location.href.indexOf("appversion") != -1
                      ? "_parent"
                      : ""
                  }
                  className="explore_ques_link"
                >
                  {lang == "en" ? (
                    <>Explore More Questions</>
                  ) : (
                    <>Watch Episodes</>
                  )}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="topicdetailtabpad">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="topic_detail">
                  <Link
                    to={
                      window.location.href.indexOf("appversion") != -1
                        ? "/?" + params
                        : "https://www.narendramodi.in/parikshapecharcha"
                    }
                    target={
                      window.location.href.indexOf("appversion") != -1
                        ? "_parent"
                        : "_blank"
                    }
                    className="backtopicdetail"
                  >
                    <img
                      src="/assets/images/backarrow.svg"
                      className=""
                      alt=""
                    />
                    <span>Back</span>
                  </Link>

                  <img
                    src="/assets/images/book.png"
                    className="bookdetail"
                    alt=""
                  />
                  <img
                    src="/assets/images/girl.png"
                    className="girletail"
                    alt=""
                  />

                  <div
                    className="tpicdetail_wid"
                    style={
                      type == "shorts"
                        ? { float: "right", paddingLeft: "135px" }
                        : {}
                    }
                  >
                    {getArticleTypeHtml(type)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="thanyou_bg">
          <div className="thanyou_content">
            <h3>Thank You</h3>
            <img src="/assets/images/illu1.png" alt="" />
          </div>
        </div>
      </div>
      <SharePopup
        link={link}
        quote={quote}
        twittermessage={twittermessage}
        shareType={shareType}
      />
    </>
  );
};

export default Detail;
